"use client";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import CButton from "../../common/CButton";
//import CFolloUpOrders from "../../common/CFolloUpOrders";

import CommonMessage from "../../common/CommonMessage";
import { Button, Modal } from "react-bootstrap";
import CommonDropdown from "../../common/CommonDropdown";
import { addFollowUpRemarks } from "../../services/followUpService";
import CIFollowUpOrders from "../../common/CIFollowUpOrders";

const FollowUpInterested = () => {
    const followUpRef = useRef(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isTeam, setIsTeam] = useState(false);
    const [isPunch, setIsPunch] = useState(false);
    const [currentUserId, setCurrentUserId] = useState(null);
    const [loadingRow, setLoadingRow] = useState(null);
    
    const [message, setMessage] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [errors, setErrors] = useState({});
    const [updateStatus, setUpdateStatus] = useState("");
    const [formData, setFormData] = useState({
        remarks: "",
        followUpDate: "",
        //status: "",
    });

    const [showRemarksHistory, setShowRemarksHistory] = useState(false);
    const [selectedRemarks, setSelectedRemarks] = useState([]);
    const openRemarksHistory = (row) => {
        setSelectedRemarks(row.remarks || []);
        setShowRemarksHistory(true);
    };
    const closeRemarksHistory = () => {
        setSelectedRemarks([]);
        setShowRemarksHistory(false);
    };


    useEffect(() => {
        const roleId = Number(localStorage.getItem("roleid"));
        const role = localStorage.getItem("rolename")?.toLowerCase();

        const userPermissionRoleId = Number(
            localStorage.getItem("userPermissionRoleId")
        );

        const salesPunchRoleId = Number(
            localStorage.getItem("salesPunchRoleId")
        );

        setIsAdmin(roleId === 1 || role === "admin");

        if (
            roleId !== 1 &&
            roleId !== salesPunchRoleId &&
            roleId !== userPermissionRoleId
        ) {
            setIsTeam(true);
            setCurrentUserId(Number(localStorage.getItem("userid")));
        }
        if (roleId === salesPunchRoleId) {
            setIsPunch(true);
        }
    }, []);

    const RemarksStatus = [
        { id: 1, name: "Interested" },
        { id: 2, name: "Not Interested" },
        { id: 3, name: "Closed" },
    ]
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Clear field error while typing
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };


    // Open popup
    const openRemarksPopup = useCallback((rowData) => {
    setSelectedRow(rowData);
    setShowModal(true);
    setUpdateStatus("");

    setFormData({
        remarks: "",
        followUpDate: "",
    });

    setErrors({});
}, []);

    // Close popup
   const closeRemarksPopup = useCallback(() => {
    setShowModal(false);
    setSelectedRow(null);
    setUpdateStatus("");

    setFormData({
        remarks: "",
        followUpDate: "",
    });

    setErrors({});
}, []);

    const validate = useCallback(() => {
        const newErrors = {};

        if (!updateStatus) {
            newErrors.status = "Please select status.";
        }
        if (updateStatus === 1 && !formData.followUpDate) {
            newErrors.followUpDate = "Please select follow-up date.";
        }
        if (!formData.remarks.trim()) {
            newErrors.remarks = "Please enter remarks.";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    }, [updateStatus, formData]);

    // Confirm Cancel
    const handleRemarksOrder = useCallback(async () => {
    if (!selectedRow) return;

    if (!validate()) return;

    setLoadingRow(selectedRow.orderId);

    try {
        const payload = {
            followUpOrderAssignId: selectedRow.id,
            updateStatusId: updateStatus,
            followUpDate:
                updateStatus === 1 ? formData.followUpDate : null,
            remarks: formData.remarks,
        };

        const response = await addFollowUpRemarks(payload);

        if (response?.success) {
            setMessage(response.message || "Remarks added successfully.");
            followUpRef.current?.refresh();
        } else {
            setMessage(response?.message || "Unable to save remarks.");
        }

        closeRemarksPopup();
    } catch (error) {
        setMessage(
            error?.response?.data?.message ||
            error?.message ||
            "Something went wrong."
        );
    } finally {
        setLoadingRow(null);
    }
}, [
    selectedRow,
    updateStatus,
    formData,
    validate,
    closeRemarksPopup,
]);


    const handlePunchDoneStatus = useCallback(async (id) => {
    try {
        setLoadingRow(`punch-${id}`);

        // await PunchDoneApi(id);

        followUpRef.current?.refresh();
        setMessage("Punch completed successfully.");
    } catch (error) {
        setMessage(error?.response?.data?.message || "Something went wrong.");
    } finally {
        setLoadingRow(null);
    }
},[]);

const handleRingingStatus = useCallback(async (id) => {
    try {
        setLoadingRow(`ringing-${id}`);

        // await RingingApi(id);

        followUpRef.current?.refresh();
        setMessage("Status updated successfully.");
    } catch (error) {
        setMessage(error?.response?.data?.message || "Something went wrong.");
    } finally {
        setLoadingRow(null);
    }
},[]);

const handleDenyStatus =useCallback( async (id) => {
    try {
        setLoadingRow(`deny-${id}`);

        // await DenyApi(id);

        followUpRef.current?.refresh();
        setMessage("Updated successfully.");
    } catch (error) {
        setMessage(error?.response?.data?.message || "Something went wrong.");
    } finally {
        setLoadingRow(null);
    }
},[]);

// const defaultColDef = useMemo(
//   () => ({
//     flex: 1,
//     minWidth: 220,
//     sortable: true,
//     filter: true,
//     resizable: true,
//   floatingFilter: true,
//   }),
//   []
// );
    const columnDefs = useMemo(() => {
        const columns = [];
        if (!isAdmin && ! isPunch) {
            columns.push({
                headerName: "Action",
                cellRenderer: (params) => (
                    <CButton
                        data={params.data}
                        onClick={openRemarksPopup}
                        loading={loadingRow === params.data.orderId}
                        buttontext="Add Remarks"
                    />
                ),
            });
        }

        columns.push(
            { field: "orderId", headerName: "Order ID" },
            { field: "orderType", headerName: "Order Type" },
            {
        field: "dateCreated",
        headerName: "Date Created",
      },
            { field: "wayBill", headerName: "WayBill" },
            { field: "followUpDate", headerName: "followUp Date" },
            { field: "followUpRemarks", headerName: "followUp Remarks" },
            { field: "courier", headerName: "Courier" },
            { field: "customerName", headerName: "Customer Name" },
            { field: "mobile", headerName: "Mobile" },
            { field: "email", headerName: "Email" },
            { field: "pincode", headerName: "Pincode" },
            { field: "city", headerName: "City" },
            { field: "totalAmount", headerName: "Total Amount" },
            { field: "paymentType", headerName: "Payment Type" },
            { field: "teleCaller", headerName: "Tele Caller" },
            {
                headerName: "Products",
                field: "product",
                flex: 3,
                wrapText: true,
                autoHeight: true,
            },
            { field: "diseaseName", headerName: "Disease Name" },
            { field: "courierStatus", headerName: "Courier Status" },
            { field: "dateCreated", headerName: "Date Created " },
            { field: "deliveredDate", headerName: "Delivered date" },
             {
    headerName: "Remarks",
    field: "remarks",
    width: 140,
    sortable: false,
    filter: false,
    cellRenderer: ({ data }) => {
        const count = data.remarks?.length || 0;

        return (
            <span
                style={{
                    color: "#0d6efd",
                    cursor: count > 0 ? "pointer" : "default",
                    textDecoration: count > 0 ? "underline" : "none",
                    fontWeight: 600,
                }}
                onClick={() => {
                    if (count > 0) {
                        openRemarksHistory(data);
                    }
                }}
            >
                {count} Remark{count !== 1 ? "s" : ""}
            </span>
        );
    },
},
        );
        if (isPunch) {
    columns.push({
        headerName: "Action",
        width: 350,
        minWidth: 350,
flex: 3,
sortable: false,
            filter: false,
        cellRenderer: (params) => {
            const data = params.data;

            return (
                <div className="d-flex gap-2">
                    <CButton
                        data={data}
                        onClick={() => handlePunchDoneStatus(data.id)}
                        loading={loadingRow === `punch-${data.id}`}
                        buttontext="Punch Done"
                    />

                    <CButton
                        data={data}
                        onClick={() => handleRingingStatus(data.id)}
                        loading={loadingRow === `ringing-${data.id}`}
                        buttontext="Ringing"
                    />

                    <CButton
                        data={data}
                        onClick={() => handleDenyStatus(data.id)}
                        loading={loadingRow === `deny-${data.id}`}
                        buttontext="Deny"
                    />
                </div>
            );
        },
    });
}

        return columns;
    }, [isAdmin,
    isPunch,
    loadingRow,
    openRemarksPopup,
    handlePunchDoneStatus,
    handleRingingStatus,
    handleDenyStatus,]);


    // All Grid Columns

    return (
        <>
            <CommonMessage text={message} />
            <CIFollowUpOrders
                ref={followUpRef}
                columnDefs={columnDefs}
                // defaultColDef={defaultColDef}
                h4="Follow Up Orders"
                reOrder={false}
                IsAdmin={isAdmin}
                IsTeam={isTeam}
                IsPunch={isPunch}
                userId={isPunch ? null : currentUserId}
            />

            <Modal
                show={showModal}
                onHide={closeRemarksPopup}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Remarks</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>
                        <strong>Order ID :</strong> {selectedRow?.orderId}
                    </p>

                    <div className="mb-3">
                        <CommonDropdown
                            label="Select Status"
                            options={RemarksStatus}
                            value={updateStatus}
                            onChange={(value) => setUpdateStatus(Number(value))}
                            placeholder="Select Status"
                        />

                        {errors.status && (
                            <div className="text-danger mt-1">
                                {errors.status}
                            </div>
                        )}
                    </div>
                    {/* {updateStatus} */}
                    {Number(updateStatus) === 1 && (
                        <div className="mb-3">
                            <label className="form-label">
                                Follow-up Date & Time
                            </label>

                            <input
                                type="datetime-local"
                                name="followUpDate"
                                className={`form-control ${errors.followUpDate ? "is-invalid" : ""
                                    }`}
                                value={formData.followUpDate}
                                onChange={handleChange}
                                min={new Date().toISOString().slice(0, 16)}
                            />

                            {errors.followUpDate && (
                                <div className="invalid-feedback">
                                    {errors.followUpDate}
                                </div>
                            )}
                        </div>
                    )}
                    {/* <div className="mb-3">
                        <input
                            type="textarea"
                            name="remarks"
                            rows={3}
                            className={`form-control ${
                                errors.remarks ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Remarks"
                            value={formData.remarks}
                            onChange={handleChange}
                        />

                        {errors.remarks && (
                            <div className="invalid-feedback">
                                {errors.remarks}
                            </div>
                        )}
                    </div> */}
                    <div className="mb-3">
                        <textarea
                            name="remarks"
                            rows={3}
                            className={`form-control ${errors.remarks ? "is-invalid" : ""}`}
                            placeholder="Enter Remarks"
                            value={formData.remarks}
                            onChange={handleChange}
                        />

                        {errors.remarks && (
                            <div className="invalid-feedback">
                                {errors.remarks}
                            </div>
                        )}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={closeRemarksPopup}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="primary"
                        onClick={handleRemarksOrder}
                        disabled={loadingRow === selectedRow?.orderId}
                    >
                        {loadingRow === selectedRow?.orderId
                            ? "Saving..."
                            : "Save"}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showRemarksHistory}
                onHide={closeRemarksHistory}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Remarks History ({selectedRemarks.length})
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {selectedRemarks.length === 0 ? (
                        <div className="text-center">No Remarks Found.</div>
                    ) : (
                        <table className="table table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Status</th>
                                    <th>Follow Up Date</th>
                                    <th>Remark</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedRemarks.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{index + 1}</td>
                                        <td>{item.followUpSts}</td>
                                        <td>
                                            {item.followUpDate
                                                ? new Date(item.followUpDate).toLocaleString("en-IN")
                                                : "-"}
                                        </td>
                                        <td>{item.remark}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={closeRemarksHistory}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default FollowUpInterested;